import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(ElementUI)

Vue.config.productionTip = false
new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
